import { render } from "./CopyMiroBoardPage.vue?vue&type=template&id=2d255cdf&scoped=true"
import script from "./CopyMiroBoardPage.vue?vue&type=script&lang=js"
export * from "./CopyMiroBoardPage.vue?vue&type=script&lang=js"

import "./CopyMiroBoardPage.vue?vue&type=style&index=0&id=2d255cdf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d255cdf"]])

export default __exports__